import { FC } from "react";
import { Body } from "capitalrx-components-2.0/lib/typography";

/**
 * The spacer tab component to render.
 */
export const SpacerTab: FC = () => {
  return (
    <li className="tab spacer">
      <span className="hotspot">
        <span className="content">
          <Body inline size="inherit" className="client-area">
            &nbsp;
          </Body>
        </span>
      </span>
    </li>
  );
};
